import { Button, DialogContent, Stack, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React from "react";
import useBankInfoRemove from "src/hooks/bank-info/useBankInfoRemove";

const BankInfoConfirmDelete = ({ item, onClose }) => {
  const { trigger: removeBankInfo } = useBankInfoRemove(item?._id);

  const handleConfirm = async () => {
    const res = await removeBankInfo();
    if (res?.success) {
      onClose();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };
  return (
    <DialogContent>
      <Typography>Bạn có chắc muốn xoá tài khoản ngân hàng {item?.bankName} không?</Typography>
      <Stack
        direction="row"
        spacing={2}
        justifyContent="flex-end"
        alignItems="center"
        mt={2}
      >
        <Button
          variant="outlined"
          onClick={onClose}
        >
          Hủy
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleConfirm}
        >
          Xác nhận
        </Button>
      </Stack>
    </DialogContent>
  );
};

export default BankInfoConfirmDelete;
